import React from 'react';
import defaultProfile from '../assets/default-profile.png';

interface Props {
  x: number;
  y: number;
  photoURL?: string;
}

const UserCursor: React.FC<Props> = ({ x, y, photoURL }) => {
  return (
    <div
      className="pointer-events-none fixed z-50"
      style={{ left: x + 2, top: y + 2 }}
    >
      <img
        src={photoURL || defaultProfile}
        alt="cursor"
        className="w-6 h-6 rounded-full border-2 border-white shadow"
      />
    </div>
  );
};

export default UserCursor; 